<div class="flex profile-media items-center">
  <img
    class="-[10px]"
    src="assets/images/dashboard/profile.png"
    alt="profile"
  />
  <div class="grow w-[calc(100%_-_250px)]">
    <span>{{ displayName }}</span>
    <p class="mb-0">
      {{ displayRole }}
      <i class="align-middle fa-solid fa-angle-down"></i>
    </p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li>
    <a class="flex items-center cursor-pointer" (click)="onLogout()">
      <app-feather-icon [icon]="'log-in'"></app-feather-icon>
      <span>Cerrar sesión</span>
    </a>
  </li>
</ul>
